<div class="menu-wrap">
    <ul>
        <li *ngFor="let item of data">
            <a
                *ngIf="!item.disabled"
                [routerLink]="item.menuLink"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{
                    exact: false
                }">
                <span>
                    <img src="assets/icons/{{item.icon}}" [ngClass]="item.class"/>
                </span>
                <span>{{item.menuText}}</span>
            </a>

            <custom-tooltip *ngIf="item.disabled" [tooltipMessage]="item.disabledTooltip">
                <span class="menu-tab menu-tab-disabled" tooltip-hoverable>
                    <span>
                        <img class="tab-icon-default" src="assets/icons/{{item.icon}}" [ngClass]="item.class"/>
                        <img class="tab-icon-blocked" src="assets/icons/do_not_disturb_on.svg"/>
                    </span>
                    <span>{{item.menuText}}</span>
                </span>
            </custom-tooltip>
        </li>
    </ul>
</div>
